import React from 'react';
import { VisionCard } from '../types';

interface VisionCardsGridProps {
    visionCards: VisionCard[];
    isLoaded: boolean;
}

const VisionCardsGrid: React.FC<VisionCardsGridProps> = ({
    visionCards,
    isLoaded,
}) => (
    <div className="w-full max-w-full mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-8 mt-4 sm:mt-20 px-0 sm:px-2">
        {visionCards.map((card, idx) => {
            const Icon = card.icon;
            return (
                <div
                    key={idx}
                    className={`group relative overflow-hidden rounded-xl sm:rounded-3xl bg-white/5 backdrop-blur-xl border border-white/10 hover:border-white/20 transition-all duration-700 hover:scale-105 hover:-translate-y-2 w-full max-w-full p-2 sm:p-0 ${isLoaded
                        ? 'opacity-100 translate-y-0'
                        : 'opacity-0 translate-y-20'
                        }`}
                    style={{ transitionDelay: `${card.delay}ms` }}
                >
                    <div
                        className={`absolute inset-0 bg-gradient-to-br ${card.gradient} opacity-0 group-hover:opacity-20 transition-opacity duration-500`}
                    />
                    <div className="relative z-10 p-2 sm:p-8 text-center sm:text-center">
                        <div className="flex items-center justify-center sm:block mb-2 sm:mb-6 gap-2 sm:gap-0">
                            <div className="w-5 h-5 bg-gradient-to-r rounded-lg flex items-center justify-center sm:hidden">
                                <Icon className="w-3.5 h-3.5 text-white" />
                            </div>
                            <h3 className="text-xs font-bold text-white mb-0 sm:hidden group-hover:text-yellow-400 transition-colors duration-300">
                                {card.title}
                            </h3>
                        </div>
                        <div className="hidden sm:block mb-6">
                            <div className={`w-16 h-16 bg-gradient-to-r ${card.gradient} rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                                <Icon className="w-8 h-8 text-white" />
                            </div>
                        </div>
                        <h3 className="hidden sm:block text-xl font-bold text-white mb-3 group-hover:text-yellow-400 transition-colors duration-300">
                            {card.title}
                        </h3>
                        <p className="text-[10px] sm:text-sm text-slate-400 leading-relaxed group-hover:text-slate-300 transition-colors duration-300 mt-1 sm:mt-0">
                            {card.description}
                        </p>
                    </div>
                    <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/20 to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
                </div>
            );
        })}
    </div>
);

export default VisionCardsGrid; 